module.exports = __webpack_public_path__ + "static/media/0m.7382e383.png";